var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobileOrTablet)?_c('div',{staticClass:"tw-hidden md:tw-inline-block tw-font-sans tw-text-xxs"},[_vm._t("prefix"),_c('span',{staticClass:"tw-font-bold"},[_vm._v(_vm._s(_vm.combinedKeyString))]),_vm._t("postfix")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }